import React from "react";
import PostApprovalPage from "./PostApprovalPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface PostApprovalPageContainerProps extends RouteProps, withValidUserRoleProps {}

const PostApprovalPageContainer = (props: PostApprovalPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <PostApprovalPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(PostApprovalPageContainer);
